import React from 'react';
import { getClassName } from 'utils/ui/classes';
const StatCard = ({ title, children, className, dataTestId }) => (React.createElement("div", { "data-testid": dataTestId, className: getClassName('px-4 py-5 sm:p-6', className) },
    React.createElement("dt", { "data-testid": "dt-190ec451", className: "text-sm font-normal text-gray-900" }, title),
    React.createElement("dd", { "data-testid": "dd-85240566", className: "mt-1 flex justify-between items-baseline md:block lg:flex" }, children)));
export default StatCard;
